import { DateTime } from 'luxon';
export var startsAfterNow = function (shift) {
    return DateTime.fromISO(shift.timeRange.start) > DateTime.local();
};
